import React, { useState } from "react";
import { sendEmail } from "../services/emailService";

const Contact = ({ data }) => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    if (data) {
        var contactName = data.name;
        var street = data.address.street;
        var city = data.address.city;
        var state = data.address.state;
        var zip = data.address.zip;
        var phone = data.phone;
        var contactEmail = data.email;
        var contactMessage = data.contactmessage;
    }

    const validateForm = () => {
        if (!name.trim()) {
            setErrorMessage("Please enter your name");
            return false;
        }
        if (!email.trim()) {
            setErrorMessage("Please enter your email");
            return false;
        }
        // Basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setErrorMessage("Please enter a valid email address");
            return false;
        }
        if (!message.trim()) {
            setErrorMessage("Please enter a message");
            return false;
        }
        return true;
    };

    const submitForm = async (e) => {
        e.preventDefault();

        // Reset messages
        setShowSuccess(false);
        setShowError(false);
        setErrorMessage("");

        // Validate form
        if (!validateForm()) {
            setShowError(true);
            return;
        }

        setLoading(true);

        // Send email using EmailJS
        const result = await sendEmail({
            name,
            email,
            subject,
            message,
        });

        setLoading(false);

        if (result.success) {
            setShowSuccess(true);
            setShowError(false);
            // Clear form
            setName("");
            setEmail("");
            setSubject("");
            setMessage("");

            // Hide success message after 5 seconds
            setTimeout(() => {
                setShowSuccess(false);
            }, 5000);
        } else {
            setShowError(true);
            setShowSuccess(false);
            setErrorMessage(result.message);
        }
    };

    return (
        <section id="contact">
            <div className="row section-head">
                <div className="two columns header-col">
                    <h1>
                        <span>Get In Touch.</span>
                    </h1>
                </div>

                <div className="ten columns">
                    <p className="lead">{contactMessage}</p>
                </div>
            </div>

            <div className="row">
                <div className="eight columns">
                    <form onSubmit={submitForm}>
                        <fieldset>
                            <div>
                                <label htmlFor="contactName">
                                    Name <span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    value={name}
                                    size="35"
                                    id="contactName"
                                    name="contactName"
                                    onChange={(e) => setName(e.target.value)}
                                    disabled={loading}
                                />
                            </div>

                            <div>
                                <label htmlFor="contactEmail">
                                    Email <span className="required">*</span>
                                </label>
                                <input
                                    type="email"
                                    value={email}
                                    size="35"
                                    id="contactEmail"
                                    name="contactEmail"
                                    onChange={(e) => setEmail(e.target.value)}
                                    disabled={loading}
                                />
                            </div>

                            <div>
                                <label htmlFor="contactSubject">Subject</label>
                                <input
                                    type="text"
                                    value={subject}
                                    size="35"
                                    id="contactSubject"
                                    name="contactSubject"
                                    onChange={(e) => setSubject(e.target.value)}
                                    disabled={loading}
                                />
                            </div>

                            <div>
                                <label htmlFor="contactMessage">
                                    Message <span className="required">*</span>
                                </label>
                                <textarea
                                    cols="50"
                                    rows="15"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    id="contactMessage"
                                    name="contactMessage"
                                    disabled={loading}
                                ></textarea>
                            </div>

                            <div>
                                <button type="submit" className="submit" disabled={loading}>
                                    {loading ? "Sending..." : "Submit"}
                                </button>
                            </div>
                        </fieldset>
                    </form>

                    {showError && (
                        <div id="message-warning" style={{ display: "block" }}>
                            {errorMessage || "Error sending message. Please try again."}
                        </div>
                    )}

                    {showSuccess && (
                        <div id="message-success" style={{ display: "block" }}>
                            <i className="fa fa-check"></i>Your message was sent successfully!
                            <br />
                        </div>
                    )}
                </div>

                <aside className="four columns footer-widgets">
                    <div className="widget widget_contact">
                        <h4>Address and Phone</h4>
                        <p className="address">
                            {contactName}
                            <br />
                            {contactEmail}
                            <br />
                            <br />
                            {street} <br />
                            {city}, {state} {zip}
                            <br />
                            <span>{phone}</span>
                        </p>
                    </div>
                </aside>
            </div>
        </section>
    );
};

export default Contact;
